<template>
  <form @submit.prevent="submit" class="container mt-lg-5 mb-5 d-flex flex-column gap-3 w-100 texto-principal">
    <!-- Campos del Formulario -->
    <h2 for="nombreFormulario">{{ form.NombreFormulario }}</h2>

    <p class="w-100" style="white-space: pre-wrap; word-wrap: break-word;">
      <span v-html="formatDescription(form.Descripcion)"></span>
    </p>
    <div v-if="form.Observacions.some(p => p.Obligatorio)" class="d-flex flex-row gap-1">
      <div class="ps-1 border border-2 border-warning fondo-terciario rounded text-danger" style="width: 20px; height: 20px;">*</div>
      <p class="text-wrap texto-terciario fs-7 w-100 m-0">{{ $t('obsObligatoria') }}</p>
    </div>
    <div v-if="form.Anonimo" class="d-flex flex-row gap-1">
      <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
        <path stroke="#9fa0a2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 0 .211-.106a4 4 0 0 1 3.578 0L14 7.5m0 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Zm-2 6.303c5-3 5 3.5 9 1.767-1 4.233-6 4.233-9 1.233-3 3-8 3-9-1.233 4 1.733 4-4.767 9-1.767Z"/>
      </svg>
      <p class="text-wrap texto-terciario fs-7 w-100 m-0">{{ $t('formAnonimo') }}</p>
    </div>

    <!-- Observaciones -->
    <div v-for="(observacion, indexObs) in form.Observacions.filter(observacion => !observacion.Oculta || observacion.ItemsObservacions.some(item => item.IdPersona == this.user.idPersona))" :key="indexObs" class="p-3 border fondo-secundario sombra-sm rounded d-flex flex-column gap-3" :class="{ 'border-warning': observacion.Obligatorio, 'borde-secundario': !observacion.Obligatorio  }">
      <!-- <div v-if="!observacion.Oculta || observacion.ItemsObservacions.some(item => item.IdPersona == user.idPersona)"> -->
        <div class="mb-0 d-flex flex-row gap-2 justify-contents-center align-items-center">
          <h4 class="m-0" id="exampleTextarea" style="">{{ observacion.NombreObservacion }} <span v-if="observacion.Obligatorio" class="text-danger">*</span></h4>
        </div>
        
        <p class="w-100 m-0" style="white-space: pre-wrap;  word-wrap: break-word;">{{ observacion.Descripcion }}</p>

        <!-- Mostrar campos diferentes según el tipo de observación -->
        <div v-if="observacion.IdTipoObservacion === '6A89FB8F-18B7-45B7-8015-AB1445BBAD4A'.toLowerCase()"><!--Texto Corto-->
          <textarea
            class="form-control sombra-sm"
            id="exampleTextarea"
            placeholder="Texto corto"
            rows="1"
            oninput="this.style.height = ''; this.style.height = this.scrollHeight + 2 + 'px'"
            style="height: 38px; resize: none;"
            v-model="observacion.Valores[0].ValorObservado"
            :required="observacion.Obligatorio"
            maxlength="200"
          ></textarea>
        </div>

        <div v-if="observacion.IdTipoObservacion === '9d19533b-3d29-4ff3-9be4-0ec902db6191'.toLowerCase()"><!--Fecha-->
          <input type="date" class="form-control sombra-sm" id="fecha" :placeholder="$t('seleccionaFecha')+'...'" v-model="observacion.Valores[0].ValorObservado" :required="observacion.Obligatorio">
        </div>

        <div v-if="observacion.IdTipoObservacion === '56cdebd4-89e8-4bb2-a26e-8f366c3f4159'.toLowerCase()"><!--Hora-->
          <input type="time" class="form-control sombra-sm" id="hora" :placeholder="$t('seleccionaHora')+'...'" v-model="observacion.Valores[0].ValorObservado" :required="observacion.Obligatorio">
        </div>

        <div v-if="observacion.IdTipoObservacion === '4BA48D01-AFEB-4D81-87D2-67FA07187CB5'.toLowerCase()" class="d-flex flex-column gap-1"><!--Opciones-->
          <!-- Items de Observación -->
          <label v-for="(item, indexItem) in observacion.ItemsObservacions" :key="indexItem" class="d-flex flex-row m-0 ms-1 align-items-center gap-2">
            <input class="form-check-input sombra-sm" type="radio" :name="'observacion_' + indexObs" v-model="observacion.Valores[0].ValorObservado" :value="item.NombreItem" :required="observacion.Obligatorio"/>
            {{ item.NombreItem }}
          </label>
        </div>

        <div v-if="observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()" class="d-flex flex-column gap-4"><!--Rango-->
          <div class="input-group mb-3">
            <span class="p-2 rounded-start-2 sombra-sm fondo-terciario texto-principal border-end border-2 borde-principal" id="basic-addon1">Valor</span>
            <input class="form-control sombra-sm" type="number" v-model="observacion.Valores[0].ValorObservado" style="max-width: 100px;" :required="observacion.Obligatorio"
             :min="observacion.ItemsObservacions?.find((item) => item.NombreItem === 'Minimo')?.ValorDeRango || 0"
             :max="observacion.ItemsObservacions?.find((item) => item.NombreItem === 'Maxima')?.ValorDeRango || 10" 
            />
          </div>
          
          
          <div class="d-flex justify-content-between align-items-center gap-3">
            <!-- Valor mínimo -->
            <span>{{ observacion.ItemsObservacions?.find((item) => item.NombreItem === 'Minimo')?.ValorDeRango || 0 }}</span>
            
            <!-- Slider de rango -->
            <input 
              type="range" 
              class="form-range sombra-sm" 
              :min="observacion.ItemsObservacions?.find((item) => item.NombreItem === 'Minimo')?.ValorDeRango || 0" 
              :max="observacion.ItemsObservacions?.find((item) => item.NombreItem === 'Maxima')?.ValorDeRango || 10" 
              :step="observacion.ItemsObservacions?.find((item) => item.NombreItem === 'StepValue')?.ValorDeRango || 0" 
              id="customRange3"
              v-model="observacion.Valores[0].ValorObservado" 
              :required="observacion.Obligatorio"
            />
            
            <!-- Valor máximo -->
            <span>{{ observacion.ItemsObservacions?.find((item) => item.NombreItem === 'Maxima')?.ValorDeRango || 10 }}</span>
          </div>
        </div>

        <div v-if="observacion.IdTipoObservacion === 'B3903AB7-FC85-45C3-AD59-7943330DB389'.toLowerCase()" class="d-flex flex-column gap-4"><!--Numero-->
          <div class="input-group mb-3">
            <span class="p-2 rounded-start-2 sombra-sm fondo-terciario texto-principal border-end border-2 borde-principal" id="basic-addon1">Valor</span>
            <input class="form-control sombra-sm" type="number" v-model="observacion.Valores[0].ValorObservado" style="max-width: 100px;" :required="observacion.Obligatorio"/>
          </div>
        </div>

        <div v-if="observacion.IdTipoObservacion === 'e42de6bc-9113-4ba6-8818-49fa8a2c0c6f'.toLowerCase()" class="btn-group w-100 sombra-sm bg-goethe-accent-claro-3" role="group" aria-label="Basic radio toggle button group" style="background-color: #DFBA6E; height: 50px;">

          <input type="radio" class="btn-check" :name="'observacion_' + indexObs" :id="'btnradio1_' + indexObs"  autocomplete="off" v-model="observacion.Valores[0].ValorObservado" :value="'Si'" :required="observacion.Obligatorio">
          <label class="btn border-end border-start d-flex align-items-center justify-content-center border-goethe-accent-claro texto-principal" :for="'btnradio1_' + indexObs">{{ $t('Si') }}</label>

          <input type="radio" class="btn-check" :name="'observacion_' + indexObs" :id="'btnradio2_' + indexObs"  autocomplete="off" v-model="observacion.Valores[0].ValorObservado" :value="'No'">
          <label class="btn border-end border-start d-flex align-items-center justify-content-center border-goethe-accent-claro texto-principal" :for="'btnradio2_' + indexObs">{{ $t('No') }}</label>

          <input type="radio" class="btn-check" :name="'observacion_' + indexObs" :id="'btnradio3_' + indexObs"  autocomplete="off" v-model="observacion.Valores[0].ValorObservado" :value="'No Observable'">
          <label class="btn border-end border-start d-flex align-items-center justify-content-center border-goethe-accent-claro texto-principal" :for="'btnradio3_' + indexObs">{{ $t('No Observable') }}</label>

        </div>

          
        <div v-if="observacion.IdTipoObservacion === 'bb1c6568-f8ea-42bc-9133-375f86fa2415'.toLowerCase()"><!--Archivo-->
          <label>{{ $t('subirArchivo') }}</label>
          <input 
            type="file" 
            class="form-control sombra-sm"  multiple
            @change="handleFileUpload($event, indexObs)" 
            :id="'archivo-' + indexObs" 
            accept=".pdf,.doc,.docx,.jpg,.png,.txt,.zip"
          />
          <small class="texto-secundario">{{ $t('tamanoMaximo') }}: 100MB</small>

          <!-- Lista de archivos subidos -->
          <div v-if="observacion.Archivo && observacion.Archivo.length > 0" class="mt-2">
            <h6>{{ $t('archivosSubidos') }}</h6>
            <ul class="list-group sombra-sm">
              <li 
                v-for="(archivo, index) in observacion.Archivo" 
                :key="index" 
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ archivo.name }}
                <button class="btn btn-danger btn-sm" @click="eliminarArchivo(indexObs, index)">
                  🗑 {{ $t('eliminar') }}
                </button>
              </li>
            </ul>
          </div>
        </div>


        <div v-if="observacion.IdTipoObservacion === '989bec4b-779d-41b0-8b28-1f1487b59ded'.toLowerCase()" class="d-flex flex-column gap-2 w-100"><!--Evaluado-->
            <!-- Eleccion de CursoGrupoAulaEspacio -->
          <div v-if="observacion.TipoEvaluado == 'Curso o Grupo'" class="position-relative">
            <input type="text" v-model="searchQueryCursosGrupos" :placeholder="$t('buscar')+'...'" class="form-control mb-2 sombra-sm" @input="filterCursosGrupos" :required="observacion.Obligatorio"/>
            <ul v-if="filteredCursosGrupos.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%;">
              <li v-for="cursoGrupo in filteredCursosGrupos"  :key="cursoGrupo.idCursoGrupo"  class="list-group-item list-group-item-action texto-principal borde-secundario" @click="selectCursoGrupo(cursoGrupo)" style="cursor: pointer;">
                {{ cursoGrupo.CursoGrupo }}
              </li>
            </ul>
            
            <div v-if="loadingCursosGrupos" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
          </div>

          <!-- Eleccion de Persona -->
          <div v-if="observacion.TipoEvaluado == 'Empleado' || observacion.TipoEvaluado == 'Profesor' || observacion.TipoEvaluado == 'Alumno' || observacion.TipoEvaluado == 'Familia'" class="position-relative">
            <input type="text" v-model="observacion.SearchQuery" :placeholder="$t('buscarPersona')+'...'" class="form-control mb-2 sombra-sm" @input="filterPersonas(observacion)" :required="observacion.Obligatorio"/>
            <ul v-if="observacion.FilteredPersonas.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%;">
              <li v-for="evaluado in observacion.FilteredPersonas"  :key="evaluado.IdPersona"  class="list-group-item list-group-item-action texto-principal borde-secundario" @click="selectPersona(evaluado, observacion)" style="cursor: pointer;">
                {{ evaluado.Apellido + ' ' + evaluado.Nombre }}
              </li>
            </ul>
            
            <div v-if="loadingPersonas" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
          </div>
          

          <div v-if="observacion.ConEleccionMateria">
            <label>{{ $t('materia') }}:</label>
            <select v-model="selectedAsignaturaId" style="width: 100%;" class="form-select sombra-sm" :required="observacion.Obligatorio">
              <option v-for="asignatura in asignaturas" :key="asignatura.IdAsignatura" :value="asignatura.IdAsignatura">
                {{ asignatura.NombreInterno + ' ' + asignatura.IdCursoGrupoNavigation.CursoGrupo}}
              </option>
            </select>
            <div v-if="loadingMaterias" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
          </div>

          <div v-if="observacion.TipoEvaluado == 'Personalizado'" class="position-relative">
            <input type="text" v-model="observacion.SearchQuery" :placeholder="$t('buscarPersona')+'...'" class="form-control mb-2 sombra-sm" @input="filterPersonas(observacion)" :required="observacion.Obligatorio"/>
            <ul v-if="observacion.FilteredPersonas.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%;">
              <li v-for="evaluado in observacion.FilteredPersonas"  :key="evaluado.IdPersona"  class="list-group-item list-group-item-action texto-principal borde-secundario" @click="selectPersona(evaluado, observacion)" style="cursor: pointer;">
                {{ evaluado.Apellido + ' ' + evaluado.Nombre }}
              </li>
            </ul>
          </div>
        </div>

        <div v-if="observacion.ConComentario" class="position-relative" style="width: 100%;">
          <label for="descripcion">{{ $t('comentario') }}</label>
          <textarea id="descripcion" v-model="observacion.Valores[0].Comentario" class="form-control sombra-sm" style="height: 120px; resize: none;" maxlength="500"></textarea>

          <div class="mt-2 text-end">
            <span>{{ observacion.Valores[0]?.Comentario.length || 0 }}/500 {{ $t('caracteres') }}</span> <!-- Actualiza el número según tu límite -->
          </div>
        </div>
    </div>
    <div v-if="loadingForm" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
      <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
    </div>
    <p v-if="status" class="m-0">{{status}}</p>
    <div class="d-flex gap-2">
      <button type="submit" class="btn btn-success sombra-sm">{{ $t('enviar') }}</button>
      <button class="btn btn-danger sombra-sm" @click="cancelForm">{{ $t('cancelar') }}</button>
      <div v-if="loadingSubmit" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
        <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
      </div>
    </div>
  </form>
</template>

<script>
  import { ref, computed, onMounted, toRaw } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const form = ref({
      Descripcion: '',
      TituloEleccionEvaluado: '',
      ConEleccionEvaluado: false,
      TipoEvaluado: '',
      ConEleccionMateria: false,
      NivelMateria: '',
      FechaCreacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      FechaModificacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      IdCreador: null,
      IdFormulario: null,
      NombreFormulario: '',
      ConAccesoRestringido : false,
      AccesoFormulario: [],
      Observacions: [], // Array de objetos para observaciones
    });
    const formTemp = ref({});

    const status = ref('');
    
    const persona = ref([]);
    const selectedPersona = ref(null); // Persona seleccionada
    const selectedAsignaturaId = ref(null); // Asignatura seleccionada
    const loadingPersonas = ref(false);
    const loadingCursosGrupos = ref(false);
    const loadingMaterias = ref(false);
    const loadingForm = ref(false);
    const loadingSubmit = ref(false);
    let idSubmit = null;
    const idForm = localStorage.getItem('idForm');

    let asignaturas = ref([]);
    let cursosGrupos = ref([]);
    const searchQueryCursosGrupos = ref('');
    const filteredCursosGrupos = ref([]);
    const selectedCursosGrupos = ref(null);

    const fetchForm = async () => {
      try {
        loadingForm.value = true;
        const response = await api.get(`api/Formularios/ByIdBasicoCompletar`, {
            params: {
                id: idForm
            },
        });
        formTemp.value = response.data.Formulario;
        const tipoPermiso = response.data.TipoPermiso;
        console.log(formTemp.value)
        // Add the additional properties to each observation
        if (formTemp.value && Array.isArray(formTemp.value.Observacions)) {
          formTemp.value.Observacions.forEach(obs => {
            if(obs.TipoEvaluado == "Personalizado"){
              obs.PersonasSeleccionadas = obs.ItemsObservacions.map(item => item.IdPersonaNavigation);
              obs.AgregarPersona = false;
              obs.FilteredPersonas = [];
              obs.SearchQuery = '';
            } else {
              obs.PersonasSeleccionadas = [];
              obs.AgregarPersona = false;
              obs.FilteredPersonas = [];
              obs.SearchQuery = '';
            }
          });
        }

        if(formTemp.value.Habilitado == false){
          console.log('Formulario deshabilitado');
          alert('Formulario deshabilitado')
          localStorage.removeItem('redirectAfterLogin');
          await router.push('/');
        }
        if(formTemp.value.ConAccesoRestringido){
          if(tipoPermiso == "Completador" || tipoPermiso == "Editor" || tipoPermiso == "Lector"){
            console.log("Tiene Permiso de Completar")
          }
          else{
            console.log('Usuario no tiene permiso a acceder.');
            alert('No tienes permiso para completar este formulario')
            localStorage.removeItem('redirectAfterLogin');
            await router.push('/formularios');
          }
        }
        else{
          console.log("Usuario Autenticado")
        }
        
        loadingForm.value = false;
        await addValor();
      } catch (error) {
        loadingForm.value = false;
        console.error('Error al obtener formularios:', error);
      }
    };

    // Obtener los tipos de observación desde la API
    const fetchPersonas = async () => {
      try {
        loadingPersonas.value = true;
        let response;
        if(form.value.TipoEvaluado != "Todos"){
          response = await api.get(`api/Persona/ByRole`, {
            params:{
              role: form.value.Observacions.find(
                      obs => ['Empleado', 'Profesor', 'Alumno', 'Familia'].includes(obs.TipoEvaluado)
                    )?.TipoEvaluado || null
            },
          });
        }
        else{
          response = await api.get(`api/Persona/ByEstado?estado=Activo`);
        }
        persona.value = response.data;
        
        loadingPersonas.value = false;
      } catch (error) {
        loadingPersonas.value = false;
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    // Obtener las Asignaturas
    const fetchAsignaturas = async () => {
      try {
        loadingMaterias.value = true;
        const response = await api.get(`api/Asignaturas/ByIdProfesor`, {
          params:{
            id: selectedPersona.value
          },
        });
        if(response.status == 200){
          asignaturas.value = response.data;
        }
        else{
          asignaturas.value = [];
          console.error('Error al obtener los tipos de observación:');
        }
        
        loadingMaterias.value = false;
      } catch (error) {
        asignaturas.value = [];
        console.error('Error al obtener los tipos de observación:', error);
        
        loadingMaterias.value = false;
      }
    };
    
    // Obtener los Cursos o Grupos
    const fetchCursosGrupos = async () => {
      try {
        loadingCursosGrupos.value = true;
        const response = await api.get(`api/Asignaturas/CursosGrupos`);
        if(response.status == 200){
          cursosGrupos.value = response.data;
        }
        else{
          cursosGrupos.value = [];
          console.error('Error al obtener los tipos de observación:');
        }
        
        loadingCursosGrupos.value = false;
      } catch (error) {
        asignaturas.value = [];
        console.error('Error al obtener los tipos de observación:', error);
        
        loadingCursosGrupos.value = false;
      }
    };

    // Filtrar CursosGrupos basadas en el input de búsqueda
    const filterCursosGrupos = () => {
      if (!searchQueryCursosGrupos.value) {
        filteredCursosGrupos.value = [];
      } else {
        const query = searchQueryCursosGrupos.value.toLowerCase();
        filteredCursosGrupos.value = cursosGrupos.value.filter(evaluado =>
          `${evaluado.CursoGrupo}`.toLowerCase().includes(query)
        );
      }
    };
    const selectCursoGrupo = (evaluado) => {
      selectedCursosGrupos.value = evaluado.IdCursoGrupo;
      searchQueryCursosGrupos.value = `${evaluado.CursoGrupo}`;
      filteredCursosGrupos.value = []; // Limpia la lista filtrada
    };

    const normalizeText = (text) => {
      if (!text) return '';
      return text
        .toLowerCase()
        .normalize("NFD") // Separa las letras de los acentos (ej: "á" -> "a" + "´")
        .replace(/[\u0300-\u036f]/g, ""); // Elimina los acentos diacríticos
    };

    // Tu función de filtro, ahora mejorada
    const filterPersonas = (observacion) => {
      if (!observacion.SearchQuery) {
        observacion.FilteredPersonas = [];
        return; // Salimos de la función si no hay búsqueda
      }

      // 1. Normalizamos y dividimos la búsqueda en palabras individuales
      const searchTerms = normalizeText(observacion.SearchQuery)
        .split(' ')
        .filter(term => term.length > 0); // Filtramos por si hay espacios extra

      // 2. Filtramos la lista de personas
      observacion.FilteredPersonas = persona.value.filter(evaluado => {
        // Creamos y normalizamos el nombre completo de la persona una sola vez
        const fullName = `${evaluado.Apellido} ${evaluado.Nombre}`;
        const normalizedFullName = normalizeText(fullName);

        // 3. Verificamos que CADA término de búsqueda esté incluido en el nombre completo
        return searchTerms.every(term => normalizedFullName.includes(term));
      });
    };
    const selectPersona = (evaluado, observacion) => {
      selectedPersona.value = evaluado.IdPersona; // Asigna la persona seleccionada
      if(observacion.ConEleccionMateria){
        fetchAsignaturas();
      }
      observacion.SearchQuery = `${evaluado.Apellido} ${evaluado.Nombre}`; // Muestra el nombre en el input
      observacion.FilteredPersonas = []; // Limpia la lista filtrada
    };
    const validateRanges = () => {
      for (let observacion of form.value.Observacions) {
        // Solo aplicamos la validación a las observaciones de tipo range
        if ((observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase())&&(observacion.Obligatorio)) {
          if (observacion.Valores[0].ValorObservado === null) {
            alert(t('seleccionarValorRango')+`: ${observacion.NombreObservacion}`);
            return false; // Si hay un campo no válido, detenemos el envío
          }
        }
      }
      return true; // Si todo está correcto, permitimos el envío
    };
    const addValor = async () => {
      //Si tiene un submit significa que se quiere editar un submit de alguien.
      idSubmit = localStorage.getItem('idSubmit');
      localStorage.removeItem('idSubmit');
      let response2;
      if(idSubmit && formTemp.value.ConEdicionDeCompletado){
        response2 = await api.get(`api/Valores/ByIdSubmit`, {
          params: {
            id: idSubmit
          },
        });
        console.log(response2.data)
      }
      for(let observacion of formTemp.value.Observacions){
        observacion.Valores = []; // Vacia los valores en caso de tener
        if(idSubmit && formTemp.value.ConEdicionDeCompletado){
          let Submit = structuredClone(response2.data)
          Submit.Valores = []
          // Aquí es donde se agregan los valores correspondientes de la respuesta
          const observacionValores = response2.data.Valores.filter(o => o.IdObservacion === observacion.IdObservacion);

          if (observacionValores.length>0) {
            // Asignar los valores encontrados a la observación
            observacionValores[0].Submit = Submit
            console.log(observacionValores)
            observacion.Valores = observacionValores; 
          }
          else{
            observacion.Valores.push({
              Submit: {
                IdEvaluador: null,
                IdEvaluado: null,
                IdAsignatura: null,
                IdCursoGrupo: null,
                FechaHora: null,
              },
              IdObservacion: observacion.IdObservacion, 
              ValorObservado: '',
              Comentario: '',
            });
          }
        }
        else{
          observacion.Valores.push({
            Submit: {
              IdEvaluador: null,
              IdEvaluado: null,
              IdAsignatura: null,
              IdCursoGrupo: null,
              FechaHora: null,
            },
            IdObservacion: observacion.IdObservacion, 
            ValorObservado: '',
            Comentario: '',
          });
        }
      }
      let observacionConEvaluado = formTemp.value.Observacions.find(o => o.IdTipoObservacionNavigation.IdTipoObservacion != '989bec4b-779d-41b0-8b28-1f1487b59ded')
      console.log(observacionConEvaluado)
      for(let observacion of formTemp.value.Observacions){
        if(observacion.IdTipoObservacionNavigation.IdTipoObservacion == '989bec4b-779d-41b0-8b28-1f1487b59ded' && observacionConEvaluado.Valores[0].Submit.IdEvaluadoNavigation?.Apellido){
          observacion.SearchQuery = `${observacionConEvaluado.Valores[0].Submit.IdEvaluadoNavigation?.Apellido ?? ''} ${observacionConEvaluado.Valores[0].Submit.IdEvaluadoNavigation?.Nombre ?? ''}`
          selectedPersona.value = observacionConEvaluado.Valores[0].Submit.IdEvaluado
        }
      }
      form.value = formTemp.value
    };

    const submit = async () => {
      if (!validateRanges()) {
        return; // Detenemos el envío si la validación de rangos falla
      }
      try {
        // Asigna la versión limpia a form
        loadingSubmit.value = true;
        let valores = []
        for(let observacion of form.value.Observacions){
          //Si la observacion NO es la de tipo Evaluado, se guarda el valor. El valor de una observacion de tipo Evaluado NO se guarda
          if(observacion.IdTipoObservacion != '989bec4b-779d-41b0-8b28-1f1487b59ded'){
            if(observacion.IdTipoObservacion == 'bb1c6568-f8ea-42bc-9133-375f86fa2415'){//Archivo
              if (observacion.Archivo && observacion.Archivo.length > 0) {
                for (let index = 0; index < observacion.Archivo.length; index++) {
                  status.value = "Subiendo archivos(" + (index+1) + "/" + observacion.Archivo.length + ")...";
                  const archivo = observacion.Archivo[index];
                  const archivoData = new FormData();
                  archivoData.append('archivo', archivo); // Agrega el archivo con la clave 'archivo'
                  let response2;
                  let success = false;
                  for (let attempt = 1; attempt <= 3; attempt++) {
                    try {
                      if(attempt>1){
                        status.value = "Reintentando subida de archivo nro " + (index+1) + "...";
                      }
                      response2 = await api.post(`api/Archivos`, archivoData);
                      if(response2.data.enlace != '' && response2.data.enlace != null){
                        success = true;
                        break;
                      }
                    } catch (error) {
                      if (attempt < 3) {
                        await new Promise(resolve => setTimeout(resolve, 1000));
                      }
                    }
                  }
                  if (!success) {
                    console.error("Error subiendo archivo después de 3 intentos");
                    alert('Ocurrió un error al subir el archivo. Intente de nuevo más tarde.');
                    loadingSubmit.value = false;
                    status.value = "";
                    return;
                  }
                  console.log("se termino de subir")

                  // Asignar valores al objeto observacion
                  if (observacion.Valores[index]) {
                    observacion.Valores[index].ValorObservado = response2.data.enlace;
                    observacion.Valores[index].Comentario = archivo.name;
                  } else {
                    observacion.Valores.push({
                      Submit: {
                        IdEvaluador: null,
                        IdEvaluado: null,
                        IdAsignatura: null,
                        IdCursoGrupo: null,
                        FechaHora: null,
                      },
                      IdObservacion: observacion.IdObservacion,
                      ValorObservado: response2.data.enlace,
                      Comentario: archivo.name,
                    });
                  }
                }
              }else if(observacion.Obligatorio){
                alert('Debe agregar un archivo')
                loadingSubmit.value = false;
                return
              }
            }
            observacion.Valores.forEach(valor => {
              valor.Submit.IdEvaluado = selectedPersona.value;
              if(!form.value.Anonimo){
                valor.Submit.IdEvaluador = user?.value.idPersona;
              }
              valor.Submit.IdAsignatura = selectedAsignaturaId.value;
              valor.Submit.IdCursoGrupo = selectedCursosGrupos.value;
              valor.ValorObservado = valor.ValorObservado.toString();
              valores.push(valor);
            });

          }
        }
        const cleanValues = JSON.stringify(toRaw(valores), null, 2); 
        
        if(idSubmit && form.value.ConEdicionDeCompletado){
          await api.put(`api/Valores`, cleanValues);
        }
        else{
          await api.post(`api/Valores`, cleanValues);
        }

        await router.push({ path: '/messagebox', query: { message: t('formEnviadoExitosamente'), redirect: t(`/formularios/misRespuestas?idForm=${form.value.IdFormulario}`) } });
        loadingSubmit.value = false;
        status.value = "";
      } catch (error) {
        console.error('Error al obtener formularios:', error);
        loadingSubmit.value = false;
        status.value = "";
      }
    };

    const handleFileUpload = (event, index) => {
      const files = event.target.files;
      if (!files.length) return;

      const maxFileSize = 110 * 1024 * 1024; // 110 MB en bytes
      const archivosValidos = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (file.size > maxFileSize) {
          alert(this.$t('archivoExcedeTamano'));
          continue; // Salta este archivo y sigue con el siguiente
        }

        archivosValidos.push(file);
      }

      if (archivosValidos.length > 0) {
        if (!form.value.Observacions[index].Archivo) {
          form.value.Observacions[index].Archivo = [];
        }

        // Agrega los archivos nuevos al array sin sobrescribir los existentes
        form.value.Observacions[index].Archivo.push(...archivosValidos);
      }

      // Limpia el input para permitir volver a subir archivos iguales si es necesario
      event.target.value = '';
    };

    // Método para eliminar un archivo de la lista
    const eliminarArchivo = (indexObs, indexArchivo) => {
      form.value.Observacions[indexObs].Archivo.splice(indexArchivo, 1);
    };

    const cancelForm = async() => {
      await router.push(`/formularios/misRespuestas?idForm=${idForm}`);
    };


    const formatDescription = (text) => {
      if (!text) return '';

      // Placeholder for existing links
      const existingLinks = [];
      let placeholderIndex = 0;

      // Regex to find existing <a> tags, capturing the full tag
      const findAndStoreLinksRegex = /<a[^>]*href=["'][^"']+\.[^"']+\.[^"']+(?:[^"']+)*["'][^>]*>.*?<\/a>/gi;

      // Step 1: Temporarily replace existing <a> tags with placeholders
      // This also handles your specific case where the URL inside href is interpolated
      let processedText = text.replace(findAndStoreLinksRegex, (match) => {
        const placeholder = `__LINK_PLACEHOLDER_${placeholderIndex}__`;
        existingLinks.push({ placeholder, original: match });
        placeholderIndex++;
        return placeholder;
      });

      // Regular expression to find URLs in the remaining plain text
      // This regex is now simpler as it only needs to look for standalone URLs
      const urlRegex = /(https?:\/\/[^\s]+)/g;

      // Step 2: Replace standalone URLs in the processed text
      processedText = processedText.replace(urlRegex, (url) => {
        // Ensure the URL isn't part of an existing placeholder's original content (redundant check but safe)
        const isAlreadyLinkedByPlaceholder = existingLinks.some(link => link.original.includes(url));
        if (isAlreadyLinkedByPlaceholder) {
          return url; // Should ideally not happen if placeholders work correctly
        }
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });

      // Step 3: Put the original <a> tags back in their place
      existingLinks.forEach(({ placeholder, original }) => {
        processedText = processedText.replace(placeholder, original);
      });

      return processedText;
    };

    onMounted(async() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      await fetchForm();
      if (form.value.Observacions.some(obs => obs.TipoEvaluado === 'Empleado') || form.value.Observacions.some(obs => obs.TipoEvaluado === 'Profesor') || form.value.Observacions.some(obs => obs.TipoEvaluado === 'Alumno') || form.value.Observacions.some(obs => obs.TipoEvaluado === 'Familia')){
        await fetchPersonas();
        form.value.Observacions.forEach(obs => {
          if (obs.TipoEvaluado === 'Empleado' || obs.TipoEvaluado === 'Profesor' || obs.TipoEvaluado === 'Alumno' || obs.TipoEvaluado === 'Familia') {
            //obs.FilteredPersonas = persona.value;
          }
        });
      }
      if(form.value.Observacions.some(obs => obs.TipoEvaluado == 'Curso o Grupo')){
        fetchCursosGrupos();
      }
      if(form.value.Observacions.some(obs => obs.TipoEvaluado == 'Personalizado')){
        const observacionPersonalizada = form.value.Observacions.find(obs => obs.TipoEvaluado == 'Personalizado');
        if (observacionPersonalizada) {
            persona.value = observacionPersonalizada.ItemsObservacions.map(item => item.IdPersonaNavigation);
        }
      }
    });

    return {
      form,
      submit,
      cancelForm,
      persona,
      selectedPersona,
      selectedAsignaturaId,
      filterPersonas,
      selectPersona,
      asignaturas,
      loadingMaterias,
      loadingCursosGrupos,
      loadingPersonas,
      loadingForm,
      loadingSubmit,
      t,
      cursosGrupos,
      searchQueryCursosGrupos,
      filteredCursosGrupos,
      selectedCursosGrupos,
      filterCursosGrupos,
      selectCursoGrupo,
      handleFileUpload,
      user,
      eliminarArchivo,
      status,
      formatDescription,
    };
  },
};
</script>

<style scoped>
  /* Estilo para el botón cuando está seleccionado */
  .btn-check:checked + label {
    background-color: var(--goethe-accent-claro-2); /* Cambia el color de fondo */
    color: var(--texto-principal); /* Cambia el color del texto */
    border-color: var(--goethe-accent-claro-2); /* Cambia el color del borde si lo deseas */
  }

  /* Estilo para el botón deseleccionado */
  .btn-check + label {
    background-color: transparent; /* Color de fondo por defecto */
    color: var(--texto-principal); /* Color del texto por defecto */
    border-color: var(--goethe-accent-claro-3); /* Color del borde por defecto */
  }
  /* Estilo para el hover */
  .btn-check + label:hover {
    background-color: var(--goethe-accent-claro-3); /* Cambia el color de fondo al hacer hover */
    cursor: pointer; /* Cambia el cursor al hacer hover */
  }
  /* Deshabilitar hover si está seleccionado */
  .btn-check:checked + label:hover {
    background-color: var(--goethe-accent-claro-2); /* Mantiene el color del botón si está seleccionado */
    color: var(--texto-principal); /* Mantiene el color del texto si está seleccionado */
  }
  /* Personalizar la pista (track) del slider */
  .form-range {
    width: 100%;
    height: 8px;
    background: var(--goethe-accent-claro-3); /* Color de la pista */
    border-radius: 5px;
    outline: none;
    transition: background 0.3s;
  }

  /* Personalizar el pulgar (thumb) del slider */
  .form-range::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background: var(--goethe-accent-claro-3);
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.3s;
  }

  .form-range::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: var(--goethe-accent-claro-3);
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.3s;
  }

  /* Cambiar el color del pulgar cuando se arrastra */
  .form-range:active::-webkit-slider-thumb {
    background-color: var(--goethe-accent-claro-2); /* Cambia el color al arrastrar */
  }

  .form-range:active::-moz-range-thumb {
    background-color: var(--goethe-accent-claro-2); /* Cambia el color al arrastrar */
  }

  .list-group {
    max-height: 200px; /* Ajusta según lo necesario */
    overflow-y: auto; /* Añade desplazamiento si es necesario */
  }

  .list-group-item {
    background-color: var(--fondo-terciario); /* Color de fondo de los items */
  }

  .list-group-item:hover {
    background-color: var(--fondo-secundario); /* Color al pasar el mouse */
  }
</style>
